import React, { useEffect, useRef } from 'react';
import EduDriveNavbar from './components/Navbar';
import Hero from './components/Hero';
import Features from "./components/Features";
import Demonstration from "./components/Demonstration";
import Footer from "./components/Footer";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Information from "./components/Information";

function App() {
    const audioRef = useRef(null);

    useEffect(() => {
        AOS.init({ duration: 800, once: true });

        const handleScroll = () => {
            if (audioRef.current) {
                audioRef.current.volume = 0.1;
                audioRef.current.play().catch(() => {});
                window.removeEventListener('scroll', handleScroll);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <EduDriveNavbar />
            <Hero />
            <Features />
            <Demonstration />
            <Information />
            <Footer />
            <audio ref={audioRef} src="/audio1.mp3" loop />
        </>
    );
}

export default App;
